import { render, staticRenderFns } from "./SelfFirst.vue?vue&type=template&id=1043ec94&scoped=true&"
import script from "./SelfFirst.vue?vue&type=script&lang=js&"
export * from "./SelfFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1043ec94",
  null
  
)

export default component.exports